export default "__VITE_ASSET__649c190f__"